import React from "react";
import { services } from "../mock";
import { Database, Shield, Sparkles, GitBranch, Boxes, Cloud, ArrowUpRight } from "lucide-react";

const icons = [Database, Shield, Sparkles, GitBranch, Boxes, Cloud];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white dark:bg-[#08132C]">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <span className="tag-chip">Core Services</span>
          <h2 className="section-title mt-4">Core end-to-end data engineering services we deliver</h2>
          <p className="section-sub mt-5">
            From migration to modernization, from real-time streaming to governed AI-ready lakehouses — we deliver end-to-end execution, not just advice.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div key={s.title} className="reveal group relative rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#0B1B3B] p-7 hover-lift overflow-hidden">
                <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-[#EEF3FF] dark:bg-[#14306A] opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative">
                  <div className="h-12 w-12 rounded-xl bg-[#0B1B3B] text-white flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-[#0B1B3B] dark:text-white leading-snug">{s.title}</h3>
                  <p className="mt-3 text-[14px] text-slate-600 dark:text-slate-300 leading-relaxed">{s.desc}</p>
                  <div className="mt-4 text-[13px] font-semibold text-[#1E56E3]">{s.highlight}</div>
                  <ul className="mt-5 space-y-2">
                    {s.points.slice(0, 4).map((p) => (
                      <li key={p} className="flex items-start gap-2 text-[13px] text-slate-700 dark:text-slate-200">
                        <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#1E56E3]" /> {p}
                      </li>
                    ))}
                  </ul>
                  <a href="#contact" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[#0B1B3B] dark:text-white group-hover:text-[#1E56E3] transition-colors">
                    Learn more <ArrowUpRight size={16} />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
